import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API, getAuthHeaders } from "../App";

const AppSettingsContext = createContext(null);

const DEFAULTS = {
  app_name: "Vault",
  app_tagline: "Operational Coordination",
  app_version: "3.0.0",
  credit_line: "Engineered & Built by Robert J Corn 2026",
  primary_color: "#D97706",
  sidebar_bg: "#1E3A5F",
  sidebar_border: "#292524",
  sidebar_text: "#A8A29E",
  sidebar_active: "#D97706",
  header_bg: "#0C0A09",
  accent_color: "#EA580C",
  logo_url: "/vault_logo.png",
};

export function AppSettingsProvider({ children, isAuthenticated }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const fetchSettings = useCallback(async () => {
    try {
      const resp = await axios.get(`${API}/admin/app-settings`, { headers: getAuthHeaders() });
      setSettings({ ...DEFAULTS, ...resp.data });
    } catch { /* use defaults */ }
  }, []);

  useEffect(() => {
    if (isAuthenticated) fetchSettings();
  }, [isAuthenticated, fetchSettings]);

  return (
    <AppSettingsContext.Provider value={{ settings, refreshSettings: fetchSettings }}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings() {
  const ctx = useContext(AppSettingsContext);
  if (!ctx) return { settings: DEFAULTS, refreshSettings: () => {} };
  return ctx;
}
